import { Paragraph5, Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '../../../../../theme/styled';
import mq from '../../../../../commons/styles/mediaQueries';
import { progressiveLoading } from '../../../../../commons/styles/animations';

const TransactionInfo = styled.div`
  display: none;

  ${mq.desktop} {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

const InfoBlockTitle = styled(Paragraph5)``;

const InfoBlockContent = styled(Paragraph4)<{ bold?: boolean }>`
  margin: 4px 0;
  font-weight: ${({ theme, bold }) => (bold ? theme.fontWeights.medium : theme.fontWeights.normal)};

  &:empty {
    padding: 8px;
    margin: 5px 12px 0 0;

    ${progressiveLoading()}
  }
`;

export default {
  TransactionInfo,
  InfoBlockTitle,
  InfoBlockContent,
};
